<script setup lang="ts">
import { cn } from '@laam/lib/utils';
import { PhCheck } from '@phosphor-icons/vue';
import {
	SelectItem,
	SelectItemIndicator,
	type SelectItemProps,
	SelectItemText,
	useForwardProps,
} from 'radix-vue';
import { type HTMLAttributes, computed } from 'vue';

const props = defineProps<
	SelectItemProps & { class?: HTMLAttributes['class'] }
>();

const delegatedProps = computed(() => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<SelectItem
		v-bind="forwardedProps"
		:class="
			cn(
				'rounded-small py-lg pl-md pr-8xl focus:bg-accent focus:text-accent-foreground relative flex w-full cursor-default select-none items-center text-md outline-none data-[disabled]:pointer-events-none data-[state=checked]:bg-gray-100 data-[disabled]:opacity-50',
				props.class,
			)
		"
	>
		<span class="right-md absolute flex items-center justify-center">
			<SelectItemIndicator>
				<PhCheck class="h-3xl w-3xl text-blue-600" weight="bold" />
			</SelectItemIndicator>
		</span>
		<SelectItemText>
			<slot />
		</SelectItemText>
	</SelectItem>
</template>
